// extracted by mini-css-extract-plugin
export default {"search":"Search_search__6oISw","clearSearch":"Search_clearSearch__Axk+q"};